import React from 'react';
import { PaymentContext } from '../context/PaymentContext';
import { IPaymentContext } from '../context/PaymentContext/context';

export default () => React.useContext<IPaymentContext>(PaymentContext);
